import { intersection } from 'lodash';
import { UserData, UserRole, UserRoleName } from 'components/UserDataContext/types';
import { RoleTypeId } from 'api/dict/params';

export const getRoleTypeIdsByUserRoles = (userRoleSet?: UserRole[]) => {
  const roleTypeIds = new Set<string>();
  userRoleSet?.forEach((role) => {
    switch (role.name) {
      case UserRoleName.VETERINARIAN:
        roleTypeIds.add(RoleTypeId.CLINIC);
        roleTypeIds.add(RoleTypeId.CONSUMER);
        break;
      case UserRoleName.APOTHECARY:
        roleTypeIds.add(RoleTypeId.DISTRIBUTOR);
        break;
      default:
        break;
    }
  });
  return Array.from(roleTypeIds);
};

export const filterSupervisedObjects = (userData: UserData | null, bewId: string) => {
  if (!userData?.supervisedObjects?.length || !bewId) {
    return [];
  }
  const roleTypeIds = getRoleTypeIdsByUserRoles(userData?.userRoleSet);

  return userData.supervisedObjects.filter(
    ({ supervisedObject }) =>
      supervisedObject.businessEntityWrapper?.id === bewId &&
      supervisedObject?.roleTypeList &&
      (!roleTypeIds?.length ||
        intersection(
          supervisedObject.roleTypeList.map((t) => t.id),
          roleTypeIds
        )?.length)
  );
};
